import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';


const profileOptions = [
    {
        Icon: LinkedInIcon,
        text: "Conta",
        link: "https://www.linkedin.com/in/luanafront/"
    },
    {
        Icon: KeyOutlinedIcon,
        text: "Segurança",
        link: ""
    },
    {
        Icon: HelpOutlineOutlinedIcon,
        text: "Perguntas frequentes",
        link: ""
    },
    {
        Icon: ChatBubbleOutlineOutlinedIcon,
        text: "Fale com o suporte",
        link: ""
    },
    {
        Icon: GitHubIcon,
        text: "GitHub",
        link: "https://github.com/luanafront"
    },
    {
        Icon: CampaignOutlinedIcon,
        text: "Envie um feedback",
        link: ""
    },
    {
        Icon: ThumbUpOutlinedIcon,
        text: "Indique a Caju",
        link: ""
    },
    {
        Icon: LogoutOutlinedIcon,
        text: "Sair",
        link: "https://caju-omega.vercel.app/"
    }
]

export default profileOptions